module.exports = __webpack_public_path__ + "static/media/ship_pink.1456d98e.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_pink.png
// module id = 205
// module chunks = 0